export class TimeSpan {
  static convertMinutesToMs(minutes: number): number{
    return minutes * 60 * 1000;
  }
};